import React, { useState } from "react";
import images from "../../../../Utils/importImages";
import {
  Button,
  CircularProgress,
  InputAdornment,
  TextField,
} from "@mui/material";
import SetPassword from "./SetPassword";
import { registerUser, VerifyOTP } from "../../../../Redux/Apis/User-Apis";
import { useSelector } from "react-redux";

function Verify_and_Create({
  onClose,
  Informer,
  setInformer,
  credential,
  credentialType,
}) {

  const [inputText, setInputText] = useState("");
  const [textError, setTextError] = useState("");
  const [isResendDisabled, setIsResendDisabled] = useState(false);

  const [resendLoading, setResednLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const [timer, setTimer] = useState(60); // Initial timer for 60 seconds

  // The actually-selected region/pipeline (set by the region dropdown in Header.jsx) — must be
  // sent with the OTP verify call instead of a hardcoded pipeline.
  const selectedPipelineId = useSelector((state) => state.user.selectedPipelineId);

  const validateInputField = (val) => {
    // validateInputField

    if (!val) {
      setTextError("*Required");
      return false;
    } else {
      if (val.length < 6) {
        setTextError(`OTP Must be of 6 Characters`);
        return false;
      } else {
        setTextError("");
        return true;
      }
    }
  };

  const onChangeInput = (e) => {
    validateInputField(e.target.value);
    setInputText(e.target.value);
  };

  let [showSetPassword, setShowPassword] = useState(false);

  // const [attemptsLeft , setAttemptsLeft] = useState
  const handleSubmit = async () => {
    let structure = {
      identifier: credential,
      otp: inputText,
      type: "register-1",
      pipeline_id: selectedPipelineId
    };

    setBtnLoading(true);
    let otpResp = await VerifyOTP(structure);
    setBtnLoading(false);

    if (otpResp.error == true) {
      return;
    }

    setShowPassword(true);
  };

  const handleResendClick = async () => {
    if (!isResendDisabled) {
      setResednLoading(true);
      await registerUser(
        Informer,
        credentialType == "phone" ? "/register/phone" : "/register/email"
      );
      setResednLoading(false);

      setIsResendDisabled(true);
      setTimer(60); // Reset timer to 60 seconds

      // Countdown function
      const countdown = setInterval(() => {
        setTimer((prevTime) => {
          if (prevTime === 1) {
            clearInterval(countdown);
            setIsResendDisabled(false); // Enable after 60 seconds
          }
          return prevTime - 1;
        });
      }, 1000);
    }
  };

  return showSetPassword == false ? (
    <div className="register-login">
      <div
        className="back-text proxima_semibold color_endeavour font12"
        onClick={() => setInformer("")}
      >
        BACK
      </div>

      <div className="header">
        <img
          src={images["user-login-icon.svg"]}
          alt=""
          className="login-icon"
        />
        <div className="title proxima_semibold color_black font22">
          Verify OTP sent to {credentialType.toUpperCase()}
        </div>
      </div>

      <div className="input-content">
        <TextField
          autoComplete="off"
          error={!!textError}
          helperText={textError}
          value={inputText}
          onChange={onChangeInput}
          onBlur={validateInputField}
          id="outlined-basic"
          label={"Enter OTP"}
          variant="outlined"
          size="small"
          sx={{
            width: "100%",
            "& .MuiInputLabel-root": {
              fontSize: "16px",
              fontFamily: `var(--font-family-proxima_nova-regular)`,
              fontStyle: "normal",
              fontWeight: "400",
              "&.Mui-focused": {
                color: "#0057B7",
              },
            },
            "& .MuiOutlinedInput-root": {
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#0057B7",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#0057B7",
              },
            },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {/* {resendLoading} */}
                <div
                  className={`resend-otp proxima_semibold font13 ${
                    isResendDisabled ? "disabled" : "color_endeavour"
                  }`}
                  onClick={handleResendClick}
                  style={{
                    cursor: isResendDisabled ? "not-allowed" : "pointer",
                    color: isResendDisabled ? "#B0B0B0" : "#0057B7",
                    textDecorationColor: isResendDisabled
                      ? "#B0B0B0"
                      : "#0057B7",
                  }}
                >
                  {resendLoading ? (
                    <CircularProgress size={18} sx={{ color: "white" }} />
                  ) : (
                    "Resend OTP"
                  )}
                </div>
              </InputAdornment>
            ),
          }}
        />
      </div>

      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        disabled={!inputText || !!textError || resendLoading || btnLoading}
        sx={{
          width: "100%",
          backgroundColor: "#0057B7",
          color: "#fff",
          fontSize: "16px",
          fontFamily: `var(--font-family-proxima_nova-semibold)`,
          marginTop: "10px",
          textTransform: "none",
          "&:hover": { backgroundColor: "#0045A5" },
          "&:disabled": {
            backgroundColor: "#B0B0B0",
            color: "#fff",
            cursor: "not-allowed",
          },
        }}
      >
        {" "}
        {btnLoading ? (
          <CircularProgress size={24} sx={{ color: "white" }} />
        ) : (
          "VERIFY AND CREATE"
        )}
      </Button>

      <div className="tandc color_light-gray-black font14 proxima_regular">
        By proceeding, you agree to TripPrizer's{" "}
        <span className="color_endeavour">Privacy Policy, User Agreement</span>{" "}
        and <span className="color_endeavour">T&Cs</span>
      </div>
    </div>
  ) : (
    <SetPassword
      credential={credential}
      credentialType={credentialType}
      onClose={onClose}
    />
  );
}

export default Verify_and_Create;
